import { render, staticRenderFns } from "./transactionsettlement.vue?vue&type=template&id=7a7d8d4b"
import script from "./transactionsettlement.vue?vue&type=script&lang=js"
export * from "./transactionsettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports